import { useMutation } from '@tanstack/react-query';

import { CancelSlotsParams, useAccountsService } from '@restworld/data-services';

function useCancelSlotsMutation() {
  const accountsService = useAccountsService();
  return useMutation({ mutationFn: (params: CancelSlotsParams) => accountsService.cancelSlots(params) });
}

export default useCancelSlotsMutation;
